import {stopPlaying} from "./playAudio.ts";
import {clearMessages} from "../messageObject/messageObjectUtils.ts";

export const resetState = async (messagesRef: any, currentMessageRef: any, messagesSequenceRef: any, setDynamicStateObj: any, setMessages: any, miscMidRenderRefs: any, updateElementInProgress: any, updateImportantMessageIds: any) => {
    updateElementInProgress('', 'abort');
    updateImportantMessageIds('', 'clear');

    stopPlaying(setDynamicStateObj, miscMidRenderRefs);
    clearMessages(messagesRef, currentMessageRef, messagesSequenceRef);
    setMessages(null);
    setDynamicStateObj({conversationId: null, errorMessage: null, editingId: null, unreviewedFileTracker: {}});
};